export class Debouncer<
  A,
  F extends (x: A) => Promise<void> = (x: A) => Promise<void>
> {
  private tout_?: ReturnType<typeof setTimeout>;
  private func_?: F;

  constructor(private delay_: number) { }

  setFunc(f: F) {
    this.func_ = f;
  }

  async call(x: A) {
    if (!this.func_) return;
    if (this.tout_) clearTimeout(this.tout_);
    this.tout_ = setTimeout(() => this.func_!(x), this.delay_);
  }
}

const debouncer = (delay: number) => {
  let tout_: ReturnType<typeof setTimeout> | undefined = undefined;

  const result = <A extends any[], F extends (...x: A) => Promise<void> = (...x: A) => Promise<void>>(func: F) => {
    return async (...x: A) => {
      if (tout_) clearTimeout(tout_);
      tout_ = setTimeout(() => {
        tout_ = undefined;
        func(...x);
      }, delay);
    }
  }
  return result;
}

export default debouncer;
